import { useEffect } from "react";
import { Navbar } from "./components";
import HomePage from "./page/home/home.page";
import Aos from "aos";
import "aos/dist/aos.css";
import emailjs from '@emailjs/browser';
import { Route, Routes } from "react-router-dom";
import HowToBuild from "./components/how-to-build";
import ProductService from "./components/services/product-service";

const App = () => {
  useEffect(() => {
    emailjs.init({
      publicKey: 'dRa56tgRrdvYKSjIe',
    });
  }, []);

  useEffect(() => {
    Aos.init({
      duration: 2500,
      delay: 400,
    });
  }, []);

  return (
    <div className="">
      <div className="relative z-50">
        <div
          className="absolute w-full"
          data-aos="fade-down"
          data-aos-duration={1500}
          data-aos-delay={1000}
        >
          <Navbar />
        </div>
      </div>
      <div>
        <div className="overflow-hidden">
          <div className="fixed h-screen">
            <div
              className="fixed top-0 max-xl:right-[-1050px] xl:right-[-970px]"
              data-aos="zoom-out-down"
              data-aos-duration={1500}
              data-aos-delay={0}
            >
              <img
                className="transition ease-in duration-200 -z-30 image"
                width="4377"
                src="https://github.githubassets.com/images/modules/site/home-campaign/hero-bg.webp"
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="absolute left-0 top-0 w-full">
          <HomePage />
        </div>
      </div>
    </div>
  );
};

const MainApp = () => {

  useEffect(() => {
    emailjs.init({
      publicKey: 'dRa56tgRrdvYKSjIe',
    });
  }, []);

  useEffect(() => {
    Aos.init({
      duration: 2500,
      delay: 400,
    });
  }, []);

  return(
    <div>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/how-we-build" element={<HowToBuild />} />
        <Route path="/service/product" element={<ProductService />} />
        <Route path="/service/staff" element={<ProductService />} />
        <Route path="*" element={<App />} />
      </Routes>
    </div>

  )
};

export default MainApp;
